import { useContext } from 'react'

import AppContext from '@/common/context/app.context'
import useUserGroups from '@/common/hooks/useUserGroups/useUserGroups'

import { getUserGroupsFromStores, mergeGroups } from './helpers'

const useViewGroups = ({ storeId, merchantId, canShareViewsWithAllGroups }) => {
  const { info } = useContext(AppContext)
  const { userGroups, fetchingUserGroups, fetchUserGroups } = useUserGroups({ storeId, merchantId })
  const ownGroups = getUserGroupsFromStores(info?.userInfo?.stores, storeId)

  const loadGroups = () => {
    if (canShareViewsWithAllGroups && !userGroups) fetchUserGroups()
  }

  return {
    groups: mergeGroups(ownGroups, canShareViewsWithAllGroups ? userGroups : []),
    ownGroupIds: ownGroups.map(group => group.id),
    fetchingUserGroups,
    loadGroups,
  }
}

export default useViewGroups
